const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource,
  updateTransientContext = _require.updateTransientContext;

/**
  * @function evalute - evaluate arrayReduceBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values === undefined || !Array.isArray(values)) {
    return undefined;
  }
  const transientContextMap = await evaluateSource(source.contextMap || source.transientContextMap, content, parentContentPath, transientContext, nativeFunctions);
  let accumulator = await evaluateSource(source.accumulator, content, parentContentPath, transientContext, nativeFunctions);
  let index;
  for (index = 0; index < values.length; index += 1) {
    const value = values[index];
    const childTransientContext = JSON.parse(JSON.stringify(transientContext));
    updateTransientContext(childTransientContext, transientContextMap, {
      accumulator,
      index,
      value,
      values
    });
    // eslint-disable-next-line no-await-in-loop
    accumulator = await evaluateSource(source.valueReduce, content, parentContentPath, childTransientContext, nativeFunctions);
  }
  return accumulator;
};
module.exports = {
  evaluate
};